import { css, jsx } from '@emotion/core';
import { Input } from 'antd';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { handleFormChange } from '@/src/register/redux/registerAccountReducer';

import Form from '@/src/shared/components/Form';
import { bp, colors } from '@/styles';

const styles = {
  inputContainer: (bool = false) => css`
    width: 100%;
    margin: 1.6rem 0;
    display: ${bool ? 'none' : 'block'};
    @media ${bp.md} {
      max-width: 36.5rem;
    }
    .ant-input {
      border-width: 1px;
      border-style: solid;
      border-color: rgb(218, 217, 215);
    }
    .has-error .ant-input {
      border-color: #aa2d2a;
    }
  `,
};

const TextInput = ({ form, info, step, currentInfo, key, onChange, onKeyPress }) => {
  const { label, persist, meta, field, formOverrides = {}, isMailing, extra } = info;
  const isInformal = field == 'Informal';
  const { register } = useSelector(state => state);
  const { isMailingAddressDisabled, isInformalNameSameAsName } = register;
  const isFieldVisible = Boolean(isMailing) && isMailingAddressDisabled;
  const dispatch = useDispatch();

  return (
    <div key={key} css={styles.inputContainer(isFieldVisible)}>
      {info.hidden ? (
        <Form.Item label={label} extra={extra}>
          {form.getFieldDecorator(field, {
            initialValue: register[field],
            ...formOverrides,
          })(
            <Input.Password
              visibilityToggle={false}
              onChange={e => {
                onChange(field, e);
              }}
              value={currentInfo}
              size="large"
            />
          )}
        </Form.Item>
      ) : (
        <Form.Item label={label} extra={extra}>
          {form.getFieldDecorator(field, {
            initialValue: register[field],
            ...formOverrides,
            ...(Boolean(isMailing) &&
              isMailingAddressDisabled && {
                rules: [{ required: false }],
              }),
          })(
            <Input
              size="large"
              disabled={
                (Boolean(isMailing) && isMailingAddressDisabled) ||
                (isInformal && isInformalNameSameAsName)
              }
              onChange={e => {
                onChange(field, e);
                if (field == 'First' && isInformalNameSameAsName) {
                  const FirstNameValue = document.getElementById('RegistrationForm_First').value;
                  dispatch(handleFormChange({ name: 'Informal', value: FirstNameValue }));
                }
              }}
              onKeyPress={e => {
                onKeyPress(field, e);
              }}
            />
          )}
        </Form.Item>
      )}
    </div>
  );
};

TextInput.defaultProps = {
  formOverrides: {},
  onChange: () => {},
  isMailing: false,
};
export default TextInput;
